import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ui/button';
import { useReporter } from '../../reporter';
import {
  planSelectionViewPlan,
  userViewsCrunchingNumbersPage,
} from '../events';
import { SequentialNodeLoader } from './SequentialNodeLoader';
import { PlanLoaderMessage } from './PlanLoaderMessage';
import { Container } from './styles.js';

export const PlanLoader = ({ messages, onClick, buttonText, isLoading }) => {
  const [isLoadingPlans, setIsLoadingPlans] = useState(false);

  const reporter = useReporter();
  const nodes = messages.map(msg => (
    <PlanLoaderMessage key={msg.text} {...msg} />
  ));

  useEffect(() => {
    reporter.tag(userViewsCrunchingNumbersPage());
  }, [reporter]);

  let btnResultsText = isLoading
    ? 'Calculating...'
    : isLoadingPlans
    ? 'Loading Plans...'
    : buttonText;

  const onButtonClick = () => {
    reporter.tag(planSelectionViewPlan());
    onClick();
    setIsLoadingPlans(true);
  };

  nodes.push(
    <Button
      variant="spinach"
      verticalPadding={5}
      horizontalPadding={10}
      onClick={onButtonClick}
      disabled={isLoading || isLoadingPlans}
      isLoading={isLoadingPlans}
    >
      {btnResultsText}
    </Button>,
  );

  return (
    <Container>
      <SequentialNodeLoader nodes={nodes} />
    </Container>
  );
};
PlanLoader.displayName = 'PlanLoader';
PlanLoader.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
  buttonText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
